
import React, { Component}  from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import cookie from 'react-cookies'

export default class CompartidoOtros extends Component {


    constructor(props) {
        super(props);
    
        this.state = { 
            resource: [],
            response: [],
            error: [],
            key: this.props.clave,
            cssClass:'',
            security: cookie.load('userBulletin')
          }
      }

    componentDidMount() {
        var key = this.props.clave;
        var url = `${API_URL}SharedUX/${key}`; 
        axios.get(url).then(response => response.data)
        .then((data) => {
            var dataFilter = data.result.filter((item)=> item.bActivo===true);
            this.setState({ resource: dataFilter });            
            document.getElementById('LoaderShared').classList.add('loader--hide');
            document.getElementById('contentShared').removeAttribute("hidden");
        })
        .catch(error => {
        });
    }    

      
    render() {
        return ( 
            <div className="boletin__section">
                <div className="share-info__others">
                    <div className="row last-courses__title">
                        <div className="col-sm-12">
                            <ul id="boletin__header-title">
                                <li className="boletin__subtitle-name share-info__others-title">
                                    <span className="boletin__subtitle-name--pl">COMPARTIDO POR OTROS EXPORTADORES</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="loader" id="LoaderShared"></div>
                    <div className="row" hidden={true} id="contentShared">
                        {this.state.resource.map((resource, index) => (
                            <div className="col-sm-6" key={resource.nCodigo}>
                                <div className="share-by-others-item">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col-sm-10 col-10">
                                            <p className="share-by-others__title">{resource.sTitulo}</p>
                                            <p className="last-course-item__extract">Compartido por: Miguel M. Anastacio Velásquez{/*resource.nUsuarioCreacion*/}</p>
                                        </div>
                                        <div className="col-sm-2 col-2 text-right">
                                            <a href={resource.sCompartido} target="_blank">
                                                <span className="share-by-others__icon"><i className={"fas fa-"+resource.sType}></i></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

}